import { PWA_INSTALL_ENABLED } from '../../config/features.js';
import { install } from '../../content/install.js';
import { useInstallPrompt } from '../../hooks/useInstallPrompt.js';
import { Icon } from '../Icon/Icon.js';

export function InstallPanel() {
  if (!PWA_INSTALL_ENABLED) {
    return null;
  }

  const { installed, install: triggerInstall } = useInstallPrompt();

  return (
    <section
      id="install"
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(54px,8vw,96px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '28px',
          padding: 'clamp(28px,4.6vw,50px)',
          background: 'var(--panel)',
          border: '1px solid var(--edge)',
          backdropFilter: 'blur(calc(var(--blur) * 1.6)) saturate(150%)',
          WebkitBackdropFilter: 'blur(calc(var(--blur) * 1.6)) saturate(150%)',
          boxShadow: 'var(--cardShadow)',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '26px',
        }}
      >
        <div style={{ position: 'relative', minWidth: 0, maxWidth: '530px' }}>
          <h2
            style={{
              margin: 0,
              font: "800 clamp(24px,3.4vw,36px)/1.08 'Plus Jakarta Sans',sans-serif",
              letterSpacing: '-.032em',
              color: 'var(--ink)',
            }}
          >
            {install.title}
          </h2>
          <p
            style={{
              margin: '13px 0 0',
              font: "500 14.5px/1.55 'Plus Jakarta Sans',sans-serif",
              color: 'var(--muted)',
              textWrap: 'pretty',
            }}
          >
            {install.description}
          </p>
        </div>
        <button
          type="button"
          onClick={triggerInstall}
          class="install-button"
          style={{
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            background: 'var(--yellow)',
            color: '#0B1B2B',
            border: 0,
            borderRadius: '999px',
            padding: '17px 26px',
            font: "700 15px/1 'Plus Jakarta Sans',sans-serif",
            cursor: 'pointer',
            flex: 'none',
            boxShadow: 'var(--glow)',
          }}
        >
          <Icon name="install_mobile" style={{ fontSize: '20px' }} />
          {installed ? install.installedLabel : install.installLabel}
        </button>
      </div>
    </section>
  );
}
